import { AxiosInstance, AxiosResponse } from "axios";
import { UserModel } from "@/models/UserModel";
import Shared from "@/common/shared";

export default class UserService {
  private axiosInstance: AxiosInstance;

  public constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  public async getProfile(): Promise<UserModel | null> {
    const url = `/User/profile`;
    const res: AxiosResponse<UserModel> = await this.axiosInstance.get<UserModel>(url);
    return res.data;
  }

  public async getUsers(): Promise<UserModel[]> {
    const url = `/User`;
    const res: AxiosResponse<UserModel[]> = await this.axiosInstance.get<UserModel[]>(url);
    return res.data;
  }

  public async getInvites(): Promise<UserModel[]> {
    const url = `/Invite`;
    const res: AxiosResponse<UserModel[]> = await this.axiosInstance.get<UserModel[]>(url);
    return res.data;
  }

  public async deleteInvite(id: string): Promise<boolean> {
    const url = `/Invite/${id}`;
    const res: AxiosResponse<UserModel[]> = await this.axiosInstance.delete<UserModel[]>(url);
    return true;
  }

  public async updateUser(user: UserModel): Promise<UserModel> {
    const url = `/User/${user.id}`;
    const res: AxiosResponse<UserModel | string> = await this.axiosInstance.post<UserModel | string>(url, user);
    if (res.status === 409) {
      const conflictError = new Error();
      conflictError.name = Shared.conflict;
      conflictError.message = res.data as string;
      return Promise.reject(conflictError);
    }
    return res.data as UserModel;
  }

  public async inviteUser(user: UserModel): Promise<UserModel> {
    const url = `/User/invite`;
    const res: AxiosResponse<UserModel | string> = await this.axiosInstance.post<UserModel | string>(url, user);
    if (res.status === 409) {
      const conflictError = new Error();
      conflictError.name = Shared.conflict;
      conflictError.message = res.data as string;
      return Promise.reject(conflictError);
    }
    return res.data as UserModel;
  }

  public async acceptInvite(id: string): Promise<UserModel> {
    const url = `/User/invite/accept/${id}`;
    const res: AxiosResponse<UserModel | string> = await this.axiosInstance.post<UserModel | string>(url);
    if (res.status === 409) {
      const conflictError = new Error();
      conflictError.name = Shared.conflict;
      conflictError.message = res.data as string;
      return Promise.reject(conflictError);
    }
    return res.data as UserModel;
  }

  public async configureZendeskUser(id: string): Promise<UserModel> {
    const url = `/Zendesk/user/${id}`;
    const res: AxiosResponse<UserModel | string> = await this.axiosInstance.post<UserModel | string>(url);
    const customError = new Error();
    if (res.status === 404) {
      customError.name = Shared.notFound;
      customError.message = Shared.messages.USER_NOT_FOUND;
      return Promise.reject(customError);
    }
    return res.data as UserModel;
  }
}
